import React, {useState} from "react";
import {Button} from "react-bootstrap";
import Swal from "sweetalert2";
import {useNavigate} from "react-router-dom";
import {plans, security} from "../env/Environment";
import {Ajax} from "../Service/ajax";

const BootstrapSection = () => {
    const session = sessionStorage.getItem("session");

    const navigate = useNavigate();
    const urlSearchParams = new URLSearchParams(window.location.search);
    const [loading, setLoading] = useState(false);


    const fetchData = async ()=>{
        setLoading(true);
        try {
            const {data} = await Ajax.postRequest("/api/v1/sub/subscription/"+plans.evaluation+"/subscribe", []);
            if(data.error){
                Swal.fire({
                    title: 'Error!',
                    text:`${data.message}`,
                    icon: 'error',
                    confirmButtonText: 'OK',
                    customClass: {
                        popup: 'custom-popup',
                        confirmButton: 'custom-button'
                    },
                    timer: 5000
                });
            }else{
                console.log(data);
                Swal.fire({
                    title: 'Success!',
                    text:`Abonnement reussi, Vous etes desormais abonnement a notre version d'evaluation`,
                    icon: 'success',
                    confirmButtonText: 'OK',
                    customClass: {
                        popup: 'custom-popup',
                        confirmButton: 'custom-button'
                    },
                    timer: 5000
                });
            }
        }catch (error){
            Swal.fire({
                title: 'Error!',
                text:`Oups! Une erreur s'est produite, veuillez reesayer plus tard.`,
                icon: 'error',
                confirmButtonText: 'OK',
                customClass: {
                    popup: 'custom-popup',
                    confirmButton: 'custom-button'
                },
                timer: 5000
            });
        }finally {
            setLoading(false);
        }
    }

    const handleNavigation = () => {
        if(session) {
            fetchData();
        } else {
            let location=window.location.origin+"/";
            if(location === window.location.href){
                navigate("/login/?target=subs")
            }else{
                let target_id=urlSearchParams.get("user");
                let target_cmp=urlSearchParams.get("cmp");
                let ref =urlSearchParams.get("ref");
                navigate(`/login?target=own-page&target_id=${target_id}&target_cmp=${target_cmp}&ref=${ref}`);
            }
        }
    };

    const handleSubscribe = () => {
        if(session) {
            Swal.fire({
                title: 'Message important',
                text: "Vous êtes sur le point de vous abonner à ce service. Soyez rassurés que toute  information personnelle qui vous sera demandée sera gardée privée et traitée conformément à notre politique de confidentialité !",
                icon: 'info',
                showCancelButton: true,
                confirmButtonColor:'#debf66',
                focusConfirm:true,
                confirmButtonText: 'Continuer',
                cancelButtonText:'Annuler'
            }).then((result) => {
                if (result.isConfirmed) {
                    handleNavigation();
                }
            })
        }else{
            let location=window.location.origin+"/";
            if(location === window.location.href){
                navigate("/login?target=subs")
            }else{
                let target_id=urlSearchParams.get("user");
                let target_cmp=urlSearchParams.get("cmp");
                let ref = urlSearchParams.get("ref");
                navigate(`/login?target=own-page&target_id=${target_id}&target_cmp=${target_cmp}&ref=${ref}`);
            }
        }
    }

    return (
        <section className="container py-5 bg-light">
            <div className="mx-auto">
                {window.location.href === window.location.origin ?(
                    <h1 className="fw-bold">Prêt à commencer ? Contactez-nous ou créez un compte.</h1>
                ):(
                    <h1 className="fw-bold">Essayez Netikash Subscribe gratuitement</h1>
                )}
                <p className="mt-3">
                    Essayez Netikash Subscribe gratuitement pendant 1 mois !

                    Découvrez la puissance de notre solution de gestion d’abonnements. Avec le Pack d’évaluation, accédez à toutes les fonctionnalités de Netikash Subscribe pendant 30 jours, sans engagement.

                    Gagnez en efficacité, simplifiez la gestion de vos clients abonnés et boostez votre chiffre d’affaires.

                    Lancez votre essai gratuit dès aujourd’hui !
                </p>
                <div className="mt-4 d-flex justify-content-center gap-3">
                    <Button
                        className="btn btn-netikash text-white"
                        onClick={handleSubscribe}
                    >
                        {loading ? (
                            <div className="d-flex justify-content-center align-items-center w-px-150">
                                <div className="spinner-border spinner-border-sm text-primary" role="status">
                                    <span className="visually-hidden">Chargement...</span>
                                </div>
                            </div>
                        ) : "Essayer Maintenant"}
                    </Button>
                    <Button
                        className="btn btn-outline-netikash"
                        onClick={() => window.open("https://akiba.netikash.com/contact", "_blank")}
                    >
                        Contactez-nous
                    </Button>
                </div>
            </div>
        </section>
    );
};

export default BootstrapSection;
